import { useState, useMemo, useCallback } from 'react';
import { removeItem, sortByPosition, sortBySelected } from '../../../utils';

export const FILTER_TITLES = {
  cities: 'Город',
  scopes: 'Специальность',
  employments: 'Тип занятости',
  experiences: 'Опыт работы',
};

export const useFilters = (states) => {
  const {
    dataFilter,
    updateQueriesFilter,
    baseVacancy,
    baseInternship,
    queriesFilter,
  } = states;

  const [currentQueries, setCurrentQueries] = useState(queriesFilter || {});
  const [openFilter, setOpenFilter] = useState(false);

  const count = useMemo(
    () => Object.values(currentQueries).flat().length,
    [currentQueries]
  );

  const inputCallback = useCallback((section, id) => {
    setCurrentQueries((prev) => {
      const list = prev[section] || [];
      const nextList = list.includes(id) ? removeItem(list, id) : [...list, id];

      const next = { ...prev, [section]: nextList };
      if (!nextList.length) delete next[section];
      return next;
    });
  }, []);

  const apply = useCallback(() => {
    updateQueriesFilter(
      Object.keys(currentQueries).length ? currentQueries : null
    );
    setOpenFilter(false);
  }, [currentQueries, updateQueriesFilter]);

  const reset = useCallback(() => {
    setCurrentQueries({});
    updateQueriesFilter(null);
  }, [updateQueriesFilter]);

  const citiesWithVacancies = useMemo(() => {
    if (!dataFilter?.cities) return [];

    const setNames = new Set(
      [...(baseVacancy || []), ...(baseInternship || [])]
        .map((v) => v.city?.name)
        .filter(Boolean)
    );

    if (!setNames.size) return [];

    return dataFilter.cities.filter((c) => setNames.has(c.name));
  }, [dataFilter, baseVacancy, baseInternship]);

  const sections = useMemo(() => {
    if (!dataFilter) return [];

    return Object.entries(dataFilter)
      .filter(([key]) => key !== 'professionalRoles')
      .map(([key, list]) => {
        let items = list;

        if (key === 'cities') items = citiesWithVacancies;
        if (key === 'scopes') items = sortByPosition(items);

        return {
          key,
          title: FILTER_TITLES[key] || null,
          items: sortBySelected(items, currentQueries[key] || []),
        };
      });
  }, [dataFilter, citiesWithVacancies, currentQueries]);

  return {
    currentQueries,
    openFilter,
    setOpenFilter,
    inputCallback,
    apply,
    reset,
    count,
    sections,
  };
};
